import {
    FETCH_CUS_SERVICE_MILESTONES,
    FETCH_CUS_SERVICE_MILESTONE_DETAIL,
    CREATE_CUS_SERVICE_MILESTONE,
    UPDATE_CUS_SERVICE_MILESTONE,
    DELETE_CUS_SERVICE_MILESTONES,
    UPDATE_CUS_SERVICE_MILESTONE_FIELD
} from '@/redux/actions/types';

/**
 * Trạng thái khởi tạo cho module CusServiceMilestones
 */
const INIT_STATE = {
    list: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30
        }
    },
    detail: null,
    createResult: null,
    updateResult: null,
    deleteResult: null,
    statistics: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_CUS_SERVICE_MILESTONES: {
            return {
                ...state,
                list: {
                    items: action.payload?.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload.current_page),
                        total: parseInt(action.payload.total),
                        perPage: parseInt(action.payload.per_page),
                    }
                }
            };
        }

        case FETCH_CUS_SERVICE_MILESTONE_DETAIL: {
            return {
                ...state,
                detail: action.payload || null
            };
        }

        case CREATE_CUS_SERVICE_MILESTONE: {
            return {
                ...state,
                createResult: action.payload || null
            };
        }

        case UPDATE_CUS_SERVICE_MILESTONE: {
            return {
                ...state,
                updateResult: action.payload || null
            };
        }

        // merge field mới vào list.items ngay lập tức
        case UPDATE_CUS_SERVICE_MILESTONE_FIELD: {
            const { id, data } = action.payload;
            return {
                ...state,
                list: {
                    ...state.list,
                    items: state.list.items.map(item =>
                        item.id === id ? { ...item, ...data } : item
                    )
                }
            };
        }

        case DELETE_CUS_SERVICE_MILESTONES: {
            return {
                ...state,
                deleteResult: action.payload || null
            };
        }

        default:
            return state;
    }
};
